// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2iJ3-","tab":"Tabs_tab__X48qe","tabActive":"Tabs_tabActive__T5nK4"};